import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { PopupToasterService } from '../services/popup-toaster.service';

@Injectable()
export class RequestTimeoutHttpInterceptor implements HttpInterceptor {
  constructor(private popupToaster: PopupToasterService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(req).pipe(
      tap({
        // Operation failed; error is an HttpErrorResponse
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 504) {
              this.popupToaster.error(
                $localize`Workflow Timeout`,
                $localize`Your workflow has timed out`
              );
            }
          }
        }
      })
    );
  }
}
